import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import { installViewTransitionMotionGuard } from './utils/view-transition-tracker.ts'

if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
	void import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

// Suppress Framer Motion mount animations during view transitions —
// see comments in view-transition-tracker.ts for the full rationale.
installViewTransitionMotionGuard()

startTransition(() => {
	hydrateRoot(document, <HydratedRouter />)
})
